export default __webpack_public_path__ + "static/summaries-7e3981b0ffd8946c8763d592ef7a147b.png";